import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/**
 * TimePickerInput
 * A safe, reusable time picker input using react-datepicker.
 * Accepts either a Date object or a date/time string as `value`.
 */
const TimePickerInput = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  invalid = false,
}) => {
  const selectedValue =
    value instanceof Date
      ? value
      : value
      ? new Date(value)
      : null;

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full mb-4">
      {label && (
        <label
          htmlFor={id}
          className="text-base font-medium text-gray-800 whitespace-nowrap"
        >
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}

      <div className="flex-1 w-full">
        <DatePicker
          id={id}
          selected={selectedValue}
          onChange={onChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="h:mm aa"
          disabled={disabled}
          className={`w-full px-2 py-2 border-0 border-b-2 ${
            invalid ? "border-b-red-500" : "border-b-gray-300"
          } rounded-none shadow-none text-black focus:outline-none focus:ring-0 focus:border-b-indigo-500 bg-slate-50 font-medium`}
          wrapperClassName="w-full"
        />
      </div>
    </div>
  );
};

export default TimePickerInput;
